export default __webpack_public_path__ + "static/media/logo_2.00c5e8fc.jpg";